(function ($) {
	$.fn.field = function () {
		let $el;
		let $input;
		const $invalidClass = 'field--invalid';
		const $validClass = 'field--valid';
		const $activeClass = 'field--active';

		// Init the function.
		const init = function () {
			$input = $el.find('.field__input');

			// If disabled, turn the field off and kill it.
			if ($input.prop('disabled')) {
				return;
			}

			// Updating field value on input so we can use it for styling.
			$input.change(function () {
				this.setAttribute('value', this.value);
			});

			// If the input is a number, forbid letter "e" and minus sign.
			if ($input.attr('type') === 'number') {
				$input.keydown(function (e) {
					if (e.which === 69 || e.which === 109 || e.which === 189) {
						e.preventDefault();
					}
				});
			}

			// If input type="text", validate if it has a value.
			if ($input.attr('type') === 'text') {
				$input.change(function () {
					if ($input.val() !== '') {
						$el.addClass($validClass);
					} else {
						$el.removeClass($validClass);
					}
				});
			}

			// If user clicked, then...
			$input.click(function () {
				setActive();
			});

			$input.focusin(function () {
				setActive();
			});

			$input.blur(function () {
				removeActive();

				// If imput is required, validate it.
				if ($input.prop('required') && $input.val().length === 0) {
					setError();
				}
			});
		};

		// setError
		const setError = function () {
			// Add the invalid class.
			$el.addClass($invalidClass);

			// Remove the valid class.
			$el.removeClass($validClass);
		};

		// setActive
		const setActive = function () {
			// Add the active class.
			$el.addClass($activeClass);
			// Remove the invalid class.
			$el.removeClass($invalidClass);
			$el.removeClass($validClass);
		};

		// removeActive
		const removeActive = function () {
			// Remove the active class.
			$el.removeClass($activeClass);
		};

		// Loop through each element.
		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).field();
				});
			} else {
				$el = this;
				init();
			}
		}

		// Return this for chaining.
		return this;
	};

	// Init the plugin.
	$(function () {
		$('.field').field();
	});
})(jQuery);
